import type { MessageGroup, SaveMessageGroupInput, Worker } from "./types";

export type AnnouncementConfig = {
  testMode: boolean; accountConfigured: boolean; senderConfigured: boolean;
  testReceiverConfigured: boolean; bulkDelayMs: number;
  finishNotificationsEnabled?: boolean; finishPriceIncluded?: boolean;
  credentialSource?: "stored" | "environment" | "none";
  apiKeyHint?: string; userIdHint?: string; senderHint?: string;
  updatedAt?: string | null; updatedBy?: string | null;
};
export type Recipient = { id: string; name: string; exists: boolean; active: boolean; deliverable: boolean };
export const hasSmsPhone = (phone: string) => /^0\d{8,10}$/.test(phone.replace(/[^0-9]/g, ""));
export const canUseGateway = (config: AnnouncementConfig | null) => !!config && (config.testMode || config.accountConfigured && config.senderConfigured);
export function recipientDetails(ids: readonly string[], workers: Worker[], remembered: ReadonlyMap<string, string> = new Map()): Recipient[] {
  const map = new Map(workers.map(worker => [worker.id, worker]));
  return [...new Set(ids)].map(id => { const worker = map.get(id), exists = worker?.kind === "human"; return { id, name: worker?.displayedName ?? remembered.get(id) ?? "알 수 없는 작업자", exists, active: exists && worker.active, deliverable: exists && hasSmsPhone(worker.phone) }; });
}
export const recipientStatus = (recipient: Recipient) => !recipient.exists ? "작업자 정보 없음" : !recipient.deliverable ? "연락처 미등록" : !recipient.active ? "비활성" : "연락처 등록";
export const groupDraft = (group?: MessageGroup): SaveMessageGroupInput => ({ name: group?.name ?? "", workerIds: group?.members.map(member => member.workerId) ?? [] });
export const groupVersion = (group?: MessageGroup) => group ? JSON.stringify({ name: group.name, ids: group.members.map(member => member.workerId).sort(), updatedAt: group.updatedAt }) : "missing";
export const copyGroupName = (name: string) => `${name.slice(0, 94)} (복사본)`;
export function groupErrors(draft: SaveMessageGroupInput, workers: Worker[]) {
  const errors: Record<string, string> = {};
  if (!draft.name.trim() || draft.name.trim().length > 100) errors.name = "그룹 이름을 1~100자로 입력해 주세요.";
  if (!draft.workerIds.length || draft.workerIds.length > 300) errors.members = "수신자를 1~300명 선택해 주세요.";
  else if (recipientDetails(draft.workerIds, workers).some(member => !member.exists)) errors.members = "작업자 정보가 없는 수신자는 선택을 해제해 주세요.";
  return errors;
}
export function moveGroup(ids: string[], source: string, target: string) {
  const from = ids.indexOf(source), to = ids.indexOf(target);
  if (from < 0 || to < 0 || from === to) return ids;
  const next = [...ids]; next.splice(to, 0, next.splice(from, 1)[0]); return next;
}
